;var doodleExplode = (function ($) {
	'use strict';

	$(function () {
		var pieces = [];
		var figures = $('.article__doodle-bg.explode');
		var scenesFirst = [];
		var scenesLast = [];
		var isPolygon = false;

		if(figures.length) {
			/*
			* Determine the color of the doodles
			*/
			if($('.article').hasClass('has--polygon-bg')) {
				isPolygon = true;
			}

			$(figures).each(function() {
				$(this).find('svg use').each(function(index) {
					if(pieces[index] == null) {
						pieces[index] = [];
					}

					pieces[index].push(this);
				});
			});
		}

		/*
		* We make use of GSAP for the animation
		* We will have two main 'scenes' (scenesFirst & scenesLast)
		* The first will be from an 'exploded' doodle state to default state
		* The second will be from a default doodle state to the 'exploded' state
		* For each piece we apply a scale, rotate and move effect
		*/

		// Make the first scene with all effects a duration of 600px scrolled so that the doodle
		// is in its complete default state after 600px scrolled
		if(!isPolygon) {
			$(pieces).each(function() {

				// From scale 0.5-1.3 to 1 
				var scale_tween = TweenMax.fromTo(this, 1, {
					scale: getRndInteger(0.5, 1.3)
				}, {
					scale: 1,
					ease: Power1.easeOut
				});
				var scale_scene = new ScrollMagic.Scene({
					duration: 600
				}).setTween(scale_tween);

				// From rotation -50-50 degrees to 0 degrees
				var rotate_tween = TweenMax.fromTo(this, 1, {
					rotation: Math.floor(getRndInteger(-50, 50))
				}, {
					rotation: 0,
					ease: Power1.easeOut
				});
				var rotate_scene = new ScrollMagic.Scene({
					duration: 600
				}).setTween(rotate_tween);

				// From x (-100-150) and y (-300-300) position to 0, 0
				var move_tween = TweenMax.fromTo(this, 1, {
					x: Math.floor(getRndInteger(-100, 150)),
					y: Math.floor(getRndInteger(-300, 300))
				}, {
					x: 0,
					y: 0,
					ease: Power1.easeOut
				});
				var move_scene = new ScrollMagic.Scene({
					duration: 600
				}).setTween(move_tween);

				scenesFirst.push(scale_scene, rotate_scene, move_scene);
			});
		}

		// Make the second scene, all effects have an offset duration of 850
		$(pieces).each(function() {
			var offset = isPolygon ? 25 : 850;

			// From scale default to 0.4-1.6 with a duration of 1000-5000px
			var scale_tween = TweenMax.fromTo(this, 1, {
			}, {
				scale: getRndInteger(0.4, 1.6)
			});
			var scale_scene = new ScrollMagic.Scene({
				duration: Math.floor(getRndInteger(1000, 5000)),
				offset: offset
			}).setTween(scale_tween);
			
			// From rotation default to -180-180 degrees with a duration of 4000-10000px
			var rotate_tween = TweenMax.fromTo(this, 1, {
			}, {
				rotation: Math.floor(getRndInteger(-180, 180))
			});
			var rotate_scene = new ScrollMagic.Scene({
				duration: Math.floor(getRndInteger(4000, 10000)),
				offset: offset
			}).setTween(rotate_tween);

			// From position default to x (-200-400) and y (-1200-1200) with a duration of 4000-10000px
			var move_tween = TweenMax.fromTo(this, 1, {
			}, {
				x: Math.floor(getRndInteger(-200, 400)),
				y: Math.floor(getRndInteger(-1200, 1200))

			});
			var move_scene = new ScrollMagic.Scene({
				duration: Math.floor(getRndInteger(4000, 10000)),
				offset: offset
			}).setTween(move_tween);
			scenesLast.push(scale_scene, rotate_scene, move_scene);
		});

		var controller = new ScrollMagic.Controller();

		// Add both scenes to the controller and on page load it will start!
		controller.addScene(scenesFirst.concat(scenesLast));
	});


function getRndInteger(min, max) {
	return Math.random() * (max - min) + min;
}

})(jQuery);